// Internal Imports
import * as AgGrid from "../../mashupV2";
import { API_ENDPOINTS, GRID } from "../../constants";
import { get, put } from "../../api/index";
import store from "../../store";
import { GlobalUtils } from "../../utils";
// Destructuring
const { APIS } = API_ENDPOINTS;
const { GRID_PAGE_TYPE } = GRID;
const { readDataFromLocalStorage } = GlobalUtils;

export const getViewConfig = async () => {
  const getAppView = readDataFromLocalStorage("appView");
  const { ProductsView } =
    getAppView && getAppView.views ? getAppView.views : {};
  const gridConfig = await get(`${APIS.VIEW_METADATA}/${ProductsView}`)
    .then(res => {
      const data = AgGrid.formatColumnData(res, GRID_PAGE_TYPE.PRODUCTS);
      return data;
    })
    .catch(error => {
      throw error;
    });
  return gridConfig;
};

export const getProducts = async view => {
  const getAppView = readDataFromLocalStorage("appView");
  const { ProductsView } =
    getAppView && getAppView.views ? getAppView.views : {};
  const products = await get(`${APIS.VIEWS}/${ProductsView}`)
    .then(res => AgGrid.formatRowData(res.ViewData.rowData, view))
    .catch(error => {
      throw error;
    });
  return products;
};

export const getCategories = async () => {
  const products = await get(`${APIS.CATEGORIES}`)
    .then(res => res)
    .catch(error => {
      throw error;
    });
  return products;
};

export const getProductFamilies = async () => {
  const families = await get(`${APIS.PRODUCT_FAMILIES}`)
    .then(res => res)
    .catch(error => {
      throw error;
    });
  return families;
};

export const updateProductService = obj => {
  const state = store.getState().ProductsStore;
  const { tableId, tblViewId } = state.metaData;
  const url = `${APIS.TABLES}/${tableId}?view_id=${tblViewId}`;
  return new Promise((resolve, reject) => {
    put(url, [obj])
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};
